import { getMixpanel, handleError } from '@domain-group/fe-helper';
import { getBaseProps, getUserProps } from '..';
import getEntryPoint from '../get-entry-point';
import { getVisibleLandingPageModules } from './modules';
import type { FaaLandingPageModule } from './modules';

const trackViewLandingPage = (
  modules: FaaLandingPageModule[] = getVisibleLandingPageModules(),
): void => {
  try {
    const mixpanel = getMixpanel();
    const entryPoint = getEntryPoint();

    mixpanel.track('View FAA Landing Page', {
      ...getBaseProps(),
      ...getUserProps(),
      ...(entryPoint && { entryPoint }),
      siteSection: 'Agents',
      modules,
      modulesCount: modules.length,
    });
  } catch (err) {
    handleError(err);
  }
};

export default trackViewLandingPage;
